import { IMap } from '../i-map';
import { IPortalConfig } from './i-portal-config';

//Common config across portals
export class BasePortalConfig implements IPortalConfig {
  portalName: string = '';
  searchApplicable: boolean = true;
  actionCenterApplicable: boolean = true;
  directoryPickerApplicable: boolean = true;
  titleKey: string = '';
  aboutSubTitleKey: string = '';
  preferencesApplicable = false;
  woboApplicable = false;
  signInPath = '';
  signOutPath = '/aad?action=signout';
  signInRedirectPath = `/aad?action=signin&returnPath=${document.location.href}`;
  pushSurveyId: string = '';
  pullSurveyId: string = '';
  supportPanelIntegrationId: string = '';
  surveyIntegrationId: string = '';
  useFeedbackPanel: boolean = true;
  useSupportExtFeatures: boolean = true;
  useFDSurveyEndpoint = false;
  apiEndpoints: IMap = {};
  homeUrl: string = '/dashboard/home';

  constructor() {
    this.setApiEndpoints();
  }

  setApiEndpoints() {
    this.apiEndpoints = {
      auth: '',
      preference: '',
    };
  }
}
